import { render, staticRenderFns } from "./symbol-icon.vue?vue&type=template&id=7484980c&"
import script from "./symbol-icon.vue?vue&type=script&lang=js&"
export * from "./symbol-icon.vue?vue&type=script&lang=js&"
import style0 from "./symbol-icon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports